import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';

const IcepackFillerCustomModalCell = ({ rowData }) => {
	if (rowData.id === 'author') {
		return (
			<span className="icepack-filler-custom-modal-cell__author">
				<b>{rowData.value.name}</b>
				<small>
					<i>{rowData.value.role}</i>
				</small>
			</span>
		);
	}

	return rowData.value || '-';
};

IcepackFillerCustomModalCell.propTypes = {
	rowData: PropTypes.object.isRequired,
	columnId: PropTypes.string.isRequired,
};

export { IcepackFillerCustomModalCell };
